import { mqFromDesktop } from '~/variables/breakpoints';

export default {
  container: {
    minHeight: '70px',
    padding: '0px',
    width: '100%',
    zIndex: 100,
    fontSize: '18px',
    top: '40px',
    mb: '10px',
    borderBottom: '1px solid #efefef',
    [mqFromDesktop]: {
      top: '65px',
    },
  },
  inner: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    textAlign: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',
    width: '100%',
    [mqFromDesktop]: {
      flexDirection: 'row',
      textAlign: 'initial',
      justifyContent: 'space-between',
      flexWrap: 'unset',
    },
    padding: '0px 20px',
  },
  sticky: {
    zIndex: 1000,
    backdropFilter: 'blur(6px)',
    WebkitBackdropFilter: 'blur(6px)', // Safari support
    // hacked - extend to edges so blur covers full width to avoid short edges, done this way to avoid re-structuring all dashboard containers
    marginLeft: '-20px',
    marginRight: '-20px',
    width: 'calc(100% + 40px)',
  },
};
